<template>
    <div class="mx-6">
        <div class="bg-yellow-100 rounded-b text-yellow-900 px-4 py-3 shadow-md" role="alert">
          <div class="flex">
            <div class="pr-4">
              <svg class="h-12 w-12 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                   fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <div>
              <p class="text-base">The ONLY official URL for the MAYA Token is <strong>https://www.mayagent.xyz</strong>.
                Be careful of similar looking URLs.
                For those participating in the token sale, the ONLY URL is
                <strong>mayagent.xyz</strong></p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Toptext"
}
</script>

<style>

</style>